import { render, staticRenderFns } from "./yzinfo.vue?vue&type=template&id=60a8a007&scoped=true&"
import script from "./yzinfo.vue?vue&type=script&lang=js&"
export * from "./yzinfo.vue?vue&type=script&lang=js&"
import style0 from "./yzinfo.vue?vue&type=style&index=0&id=60a8a007&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8a007",
  null
  
)

export default component.exports